import { render, staticRenderFns } from "./Editarcirugia.vue?vue&type=template&id=d958eb1c"
import script from "./Editarcirugia.vue?vue&type=script&lang=js"
export * from "./Editarcirugia.vue?vue&type=script&lang=js"
import style0 from "./Editarcirugia.vue?vue&type=style&index=0&id=d958eb1c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports